<app-menu></app-menu>
<div style="background-color: #f8f9fa;">
    <div class="fundo">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
                Sua marca, sua identidade. <br>Garanta o seu domínio hoje.
            </h1>
            <p style="color:#fff; font-size: 1.2rem;"
                class="uk-margin-small-top uk-width-2-3@m uk-margin-auto"
                uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
                Não deixe sua ideia para depois. Registre seu nome na internet com segurança, gestão simplificada e a
                melhor
                performance do mercado.
            </p>
        </div>
    </div>
</div>

<div class="uk-padding uk-section-muted">
    <div class="uk-container">
        <div class="search-container uk-grid uk-grid-collapse uk-child-width-1-2@s uk-margin-large-bottom" uk-grid
            uk-scrollspy="cls: uk-animation-scale-up; delay: 100">
            <div class="uk-flex-last@s uk-card-media-right uk-visible@m uk-flex uk-flex-middle uk-flex-center"
                style="background: white; border-radius: 0 20px 20px 0; overflow: hidden; min-height: 450px;">
                <div class="globe-container">
                    <!-- Central Globe -->
                    <i class="fa-solid fa-earth-africa globe-icon"></i>

                    <!-- Floating Extensions -->
                    <div class="domain-tag tag-com">.com</div>
                    <div class="domain-tag tag-net">.net</div>
                    <div class="domain-tag tag-ao">.ao</div>
                    <div class="domain-tag tag-gov">.gov</div>
                </div>

                <style>
                    .globe-container {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 320px;
                        height: 320px;
                    }

                    .globe-icon {
                        color: #d32f2f;
                        font-size: 16rem;
                        opacity: 0.95;
                        animation: floatIcon 6s ease-in-out infinite;
                        z-index: 2;
                    }

                    .domain-tag {
                        position: absolute;
                        width: 85px;
                        height: 85px;
                        border: 2px solid #d32f2f;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: white;
                        color: #d32f2f;
                        font-weight: 800;
                        font-size: 22px;
                        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
                        z-index: 3;
                        transition: all 0.3s ease;
                    }

                    .domain-tag:hover {
                        background: #d32f2f;
                        color: white;
                        transform: scale(1.1) !important;
                    }

                    /* Position Tags */
                    .tag-com {
                        top: -25px;
                        left: -25px;
                        animation: floatTag1 5s ease-in-out infinite;
                    }

                    .tag-net {
                        top: -10px;
                        right: -60px;
                        animation: floatTag2 6s ease-in-out infinite;
                    }

                    .tag-ao {
                        bottom: 10px;
                        left: -75px;
                        animation: floatTag3 7s ease-in-out infinite;
                    }

                    .tag-gov {
                        bottom: -25px;
                        right: -15px;
                        animation: floatTag4 5.5s ease-in-out infinite;
                    }

                    /* Animations */
                    @keyframes floatIcon {

                        0%,
                        100% {
                            transform: translateY(0) rotate(0);
                        }

                        50% {
                            transform: translateY(-10px) rotate(3deg);
                        }
                    }

                    @keyframes floatTag1 {

                        0%,
                        100% {
                            transform: translate(0, 0);
                        }

                        50% {
                            transform: translate(-5px, -15px);
                        }
                    }

                    @keyframes floatTag2 {

                        0%,
                        100% {
                            transform: translate(0, 0);
                        }

                        50% {
                            transform: translate(8px, -10px);
                        }
                    }

                    @keyframes floatTag3 {

                        0%,
                        100% {
                            transform: translate(0, 0);
                        }

                        50% {
                            transform: translate(-10px, 8px);
                        }
                    }

                    @keyframes floatTag4 {

                        0%,
                        100% {
                            transform: translate(0, 0);
                        }

                        50% {
                            transform: translate(5px, 12px);
                        }
                    }
                </style>
            </div>
            <div>
                <div class="uk-card-body uk-padding-large">
                    <h3 class="uk-text-bold highlight-text uk-margin-remove-bottom">Dê o primeiro passo</h3>
                    <h2 class="uk-margin-small-top uk-text-bold" style="color: #333;">Encontre o domínio perfeito para
                        <br> o seu negócio</h2>
                    <p style="color: #666; font-size: 1.1rem;">Milhares de oportunidades estão disponíveis. Digite o
                        nome que você deseja e descubra se ele já pode ser seu.</p>

                    <div class="uk-margin-medium-top">
                        <input id="dominioInput" class="uk-input search-input uk-width-1-1" type="text"
                            placeholder="Exemplo: minhaempresa.com" aria-label="Large" [(ngModel)]="dominio">
                    </div>

                    <button id="verificarBtn" class="btn-primary-red uk-width-1-1 uk-margin-small-top"
                        (click)="verificarDominio()" [disabled]="isLoading">
                        <span *ngIf="!isLoading">Verificar Disponibilidade</span>
                        <div *ngIf="isLoading" uk-spinner="ratio: 1"></div>
                    </button>

                    <!-- Resposta da API -->
                    <div *ngIf="resposta && !isLoading" class="uk-margin-top uk-animation-fade">
                        <div [ngClass]="alertClass" class="uk-alert uk-border-rounded">
                            <p class="uk-text-center uk-text-lead" style="margin: 0; font-weight: 500;">{{ resposta }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-prices">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <h1 class="titile uk-text-bold highlight-text">Seu domínio com o melhor preço</h1>
            <p class="uk-text-large" style="color: #555;">Escolha a extensão ideal e marque presença no mundo digital de
                forma profissional.</p>
        </div>

        <div class="uk-child-width-1-4@l uk-child-width-1-2@m uk-child-width-1-1@s uk-grid-match uk-grid uk-text-center uk-margin-medium-bottom"
            uk-grid uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
            <!-- Card .com -->
            <div>
                <div class="domain-card uk-card-body">
                    <div class="uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size:3rem; color: white;">.com</h2>
                        <span class="uk-text-uppercase" style="color: rgba(255,255,255,0.8); letter-spacing: 2px;">O
                            Mais Popular</span>
                    </div>
                    <div class="uk-padding-small">
                        <h3 class="price-text">29.990 <small>Kz/ano</small></h3>
                    </div>
                    <div class="uk-margin-small-top">
                        <a class="uk-button domain-btn uk-border-pill uk-width-1-1" target="_blank"
                            href="https://q28hpkmheelk.upmind.app/order/product?pfields%5Bsld%5D=com&catid=50381d78-0e72-d4d6-860c-8413569926e5&pid=35983e23-06e7-5409-756b-24981d210d76&sub_pids=293e8d56-9d07-2459-050a-54e853121607">
                            <span uk-icon="cart" class="uk-margin-small-right"></span>COMPRAR
                        </a>
                    </div>
                </div>

            </div>

            <!-- Card .online -->
            <div>
                <div class="domain-card uk-card-body">
                    <div class="uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size:3rem; color: white;">.online</h2>
                        <span class="uk-text-uppercase"
                            style="color: rgba(255,255,255,0.8); letter-spacing: 2px;">Moderno & Destaque</span>
                    </div>
                    <div class="uk-padding-small">
                        <h3 class="price-text">25.000 <small>Kz/ano</small></h3>
                    </div>
                    <div class="uk-margin-small-top">
                        <a class="uk-button domain-btn uk-border-pill uk-width-1-1" target="_blank"
                            href="https://q28hpkmheelk.upmind.app/order/product?pid=1e96d298-537d-4ed6-58dc-14e120637085">
                            <span uk-icon="cart" class="uk-margin-small-right"></span>COMPRAR
                        </a>
                    </div>
                </div>

            </div>

            <!-- Card .net -->
            <div>
                <div class="domain-card uk-card-body">
                    <div class="uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size:3rem; color: white;">.net</h2>
                        <span class="uk-text-uppercase" style="color: rgba(255,255,255,0.8); letter-spacing: 2px;">Redes
                            & Tecnologia</span>
                    </div>
                    <div class="uk-padding-small">
                        <h3 class="price-text">29.990 <small>Kz/ano</small></h3>
                    </div>
                    <div class="uk-margin-small-top">
                        <a class="uk-button domain-btn uk-border-pill uk-width-1-1" target="_blank"
                            href="https://q28hpkmheelk.upmind.app/order/product?pfields%5Bsld%5D=net&catid=50381d78-0e72-d4d6-860c-8413569926e5&pid=27831d63-50d8-2495-69dc-d49e176259e0&sub_pids=293e8d56-9d07-2459-050a-54e853121607">
                            <span uk-icon="cart" class="uk-margin-small-right"></span>COMPRAR
                        </a>
                    </div>
                </div>

            </div>

            <!-- Card .org -->
            <div>
                <div class="domain-card uk-card-body">
                    <div class="uk-margin-small-bottom">
                        <h2 class="uk-margin-remove uk-text-bold" style="font-size:3rem; color: white;">.org</h2>
                        <span class="uk-text-uppercase" style="color: rgba(255,255,255,0.8); letter-spacing: 2px;">Para
                            Organizações</span>
                    </div>
                    <div class="uk-padding-small">
                        <h3 class="price-text">29.990 <small>Kz/ano</small></h3>
                    </div>
                    <div class="uk-margin-small-top">
                        <a class="uk-button domain-btn uk-border-pill uk-width-1-1" target="_blank"
                            href="https://q28hpkmheelk.upmind.app/order/product?pfields%5Bsld%5D=org&catid=50381d78-0e72-d4d6-860c-84135569926e5&pid=27831d63-50d8-2495-698a-d49e176259e0&sub_pids=293e8d56-9d07-2459-050a-54e853121607">
                            <span uk-icon="cart" class="uk-margin-small-right"></span>COMPRAR
                        </a>
                    </div>
                </div>

            </div>
        </div>

        <div class="cta-specialist-section" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 300">
            <a href="https://wa.me/244937754502/?text=Ol%C3%A1%2C%20estou%20na%20p%C3%A1gina%20de%20dom%C3%ADnios%20e%20gostaria%20de%20falar%20com%20um%20especialista."
                target="_blank" class="specialist-btn">
                <i class="fa-solid fa-headset uk-margin-small-right"></i> Falar com um especialista
            </a>
        </div>
    </div>
</div>
<app-rodape></app-rodape>